"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _FormModal = _interopRequireDefault(require("./FormModal"));
var _Text = _interopRequireDefault(require("../Text"));
var _TextInput = _interopRequireDefault(require("../TextFields/TextInput"));
var _BubbleSelectBlock = _interopRequireDefault(require("../BubbleSelectBlock"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var Services = _interopRequireWildcard(require("../../services"));
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * 
 * @param {*} meta 
 */
var buildYearsOptions = function buildYearsOptions(meta) {
  var enrollmentDate = meta.enrollmentDate;
  var years = [_i18n["default"].t(_tokens["default"].labels.claims.allYears)];
  var currentYear = new Date().getFullYear();
  var startYear = enrollmentDate ? new Date(enrollmentDate * 1000).getFullYear() : currentYear;

  // If they enrolled in the current year there is no need to show anything other than the current year and "All Years"
  if (currentYear === startYear) {
    return [].concat(years, [currentYear.toString()]);
  }

  // Otherwise create an array from the year they enrolled to the current year
  // Then turn the numbers into strings
  // We add plus one to the length to include the current year
  Array.from({
    length: currentYear - startYear + 1
  }, function (v, k) {
    return k + startYear;
  }).forEach(function (year) {
    return years.push(year.toString());
  });
  return years;
};
var FilterClaims = /*#__PURE__*/function (_PureComponent) {
  function FilterClaims() {
    var _this$props$activeSor, _this$props$activeSor2, _this$props$activeFil, _this$props$activeFil2;
    var _this;
    (0, _classCallCheck2["default"])(this, FilterClaims);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, FilterClaims, [].concat(args)), _this.state = {
      patient: _this.props.activeFilters.patient ? localizationMaps.fromEnglish("patients", _this.props.activeFilters.patient) : _i18n["default"].t(_tokens["default"].labels.claims.allPatients),
      category: _this.props.activeFilters.category ? localizationMaps.fromEnglish("categories", _this.props.activeFilters.category) : _i18n["default"].t(_tokens["default"].labels.claims.allCategories),
      service: _this.props.activeFilters.service ? localizationMaps.fromEnglish("benefits", _this.props.activeFilters.service) : _i18n["default"].t(_tokens["default"].labels.claims.allServiceTypes),
      status: _this.props.activeFilters.status ? _this.props.activeFilters.status : 'All Statuses',
      year: _this.props.activeFilters.year ? localizationMaps.fromEnglish("yearOptions", _this.props.activeFilters.year) || _this.props.activeFilters.year : _i18n["default"].t(_tokens["default"].labels.claims.allYears),
      sortBy: (_this$props$activeSor = _this.props.activeSort) !== null && _this$props$activeSor !== void 0 && _this$props$activeSor.sortBy ? _this.props.activeSort.sortBy : false,
      sortDirection: (_this$props$activeSor2 = _this.props.activeSort) !== null && _this$props$activeSor2 !== void 0 && _this$props$activeSor2.sortDirection ? _this.props.activeSort.sortDirection : false,
      serviceOptions: (_this$props$activeFil = _this.props.activeFilters) !== null && _this$props$activeFil !== void 0 && _this$props$activeFil.service ? [(_this$props$activeFil2 = _this.props.activeFilters) === null || _this$props$activeFil2 === void 0 ? void 0 : _this$props$activeFil2.service] : ['All Service Types'],
      patientOptions: ['All Patients'],
      yearOptions: buildYearsOptions(_this.props.user)
    }, _this._applyFilters = function () {
      var _this$state = _this.state,
        sortBy = _this$state.sortBy,
        sortDirection = _this$state.sortDirection,
        category = _this$state.category,
        service = _this$state.service,
        year = _this$state.year,
        patient = _this$state.patient,
        status = _this$state.status;
      if (localizationMaps.toEnglish("patients", patient) === "All Patients") {
        patient = "All Patients";
      }
      if (localizationMaps.toEnglish("yearOptions", year) === "All Years") {
        year = "All Years";
      }
      var filters = {
        category: localizationMaps.toEnglish("categories", category),
        service: localizationMaps.toEnglish("benefits", service),
        year: year,
        patient: patient
      };
      if (_this.props.isMasterSite) {
        filters.status = status;
        if (!filters.status) {
          filters.status = "All Statuses";
        }
      }

      // if sortBy is false, set to false so that the sortBy and sortDirection are not sent to the API
      var sort = sortBy ? {
        sortBy: sortBy,
        sortDirection: sortDirection
      } : false;
      _this.props.applyFilters(filters, sort);
    }, _this._selectPatient = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState({
                patient: event.target.value
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this._selectCategory = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.setState({
                category: event.target.value
              });
            case 2:
              _this._setServiceOptions(localizationMaps.toEnglish("categories", event.target.value));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }(), _this._selectService = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(event) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this.setState({
                service: event.target.value
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }(), _this._setServiceOptions = function (category) {
      var serviceValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var options = ['All Service Types'];
      if (category !== 'All Categories') {
        options = ['All Service Types'].concat((0, _toConsumableArray2["default"])(_this.props.hsaClaimTypes[category].reverse()));
      }
      _this.setState({
        serviceOptions: options,
        service: serviceValue ? localizationMaps.fromEnglish("benefits", serviceValue) : localizationMaps.fromEnglish("benefits", options[0])
      });
    }, _this._handleInputChange = function (type, event, isValue) {
      _this.setState((0, _defineProperty2["default"])({}, type, isValue ? event : event.target.value));
    }, _this._handleSortByChange = function (field) {
      if (field === _this.state.sortBy) {
        // Deactivate sortBy and sortDirection
        _this.setState({
          sortBy: false,
          sortDirection: false
        });
      } else {
        // Set sortBy to new value
        var sortBy = field;
        // if sortDirection is not yet set. set it to the default
        var sortDirection = _this.state.sortDirection ? _this.state.sortDirection : 'newestFirst';
        _this.setState({
          sortBy: sortBy,
          sortDirection: sortDirection
        });
      }
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(FilterClaims, _PureComponent);
  return (0, _createClass2["default"])(FilterClaims, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var dependents;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.props.dependents && !this.props.user.isDependent)) {
                _context4.next = 7;
                break;
              }
              _context4.next = 3;
              return this.props.dependents.map(function (dependent) {
                return "".concat(dependent.firstname, " ").concat(dependent.lastname);
              });
            case 3:
              dependents = _context4.sent;
              this.setState({
                patientOptions: [_i18n["default"].t(_tokens["default"].labels.claims.allPatients), "".concat(this.props.user.firstname, " ").concat(this.props.user.lastname)].concat((0, _toConsumableArray2["default"])(dependents))
              });
              _context4.next = 8;
              break;
            case 7:
              this.setState({
                patientOptions: [_i18n["default"].t(_tokens["default"].labels.claims.allPatients), "".concat(this.props.user.firstname, " ").concat(this.props.user.lastname)]
              });
            case 8:
              // Set the initial value for serviceOptions based on the current category filter value (if it exists)
              if (this.props.activeFilters.category) {
                this._setServiceOptions(this.props.activeFilters.category, this.props.activeFilters.service);
              }
            case 9:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var categoryOptions = [].concat((0, _toConsumableArray2["default"])(Services.selectFieldOptions.categoryOptions()), [_i18n["default"].t(_tokens["default"].labels.claims.allCategories)]);
      var styles = {
        containerStyle: {
          height: 752,
          maxHeight: '90vh',
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          padding: '40px 0'
        },
        formStyle: {
          height: '100%',
          maxHeight: '100%',
          padding: '5px 40px'
        },
        titleIconWrapperStyle: {
          width: 'auto',
          paddingLeft: 40,
          paddingRight: 40,
          paddingBottom: 0
        },
        body: {
          flex: 1,
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        testid: "filter-claims-modal",
        open: true,
        close: this.props.close,
        "aria-labelledby": "Filter Claims",
        title: _i18n["default"].t(_tokens["default"].labels.claims.filterAndSortClaims),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        customContainerStyle: styles.containerStyle,
        customFormStyle: styles.formStyle,
        customTitleIconWrapperStyle: styles.titleIconWrapperStyle,
        onSave: this._applyFilters,
        onReset: this.props.resetFilters,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons.applyFilters),
        resetButtonText: _i18n["default"].t(_tokens["default"].buttons.resetFilters)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.body
      }, !this.props.isLifeStyle ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "5px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claims.category)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.claims.selectCategory),
        variant: "outlined",
        value: this.state.category,
        onChange: this._selectCategory,
        select: true,
        required: true,
        fullWidth: true,
        selectOptions: categoryOptions
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claims.serviceType)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.claims.selectService),
        variant: "outlined",
        value: this.state.service,
        onChange: this._selectService,
        select: true,
        required: true,
        fullWidth: true,
        selectOptions: this.state.serviceOptions.map(function (option) {
          return localizationMaps.fromEnglish("benefits", option);
        })
      })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claims.serviceType)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.claims.selectService),
        variant: "outlined",
        value: this.state.service,
        onChange: this._selectService,
        select: true,
        required: true,
        fullWidth: true,
        selectOptions: ['All Service Types'].concat((0, _toConsumableArray2["default"])(this.props.lsaClaimTypes)).map(function (option) {
          return localizationMaps.fromEnglish("benefits", option);
        })
      })), this.props.isMasterSite ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, "Status"), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: "Select Status",
        variant: "outlined",
        value: this.state.status,
        onChange: function onChange(event) {
          return _this2._handleInputChange('status', event);
        },
        select: true,
        required: true,
        fullWidth: true,
        selectOptions: ['All Statuses', 'Pending', 'Approved', 'Referred', 'Paid', 'Declined', 'Suspended', 'Incomplete', 'Reversed']
      })) : null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claims.yearServiceDate)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.claims.selectYear),
        variant: "outlined",
        value: this.state.year,
        onChange: function onChange(event) {
          return _this2._handleInputChange('year', event);
        },
        select: true,
        required: true,
        fullWidth: true,
        selectOptions: this.state.yearOptions
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.claims.patient)), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.claims.selectPatient),
        variant: "outlined",
        value: this.state.patient,
        onChange: this._selectPatient,
        select: true,
        required: true,
        fullWidth: true,
        selectOptions: this.state.patientOptions
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0",
        customStyle: {
          fontWeight: 500
        }
      }, _i18n["default"].t(_tokens["default"].labels.claims.sortBy)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.claims.serviceDate),
          selected: this.state.sortBy === 'serviceDate',
          field: 'serviceDate'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.claims.submissionDate),
          selected: this.state.sortBy === 'submissionDate',
          field: 'submissionDate'
        },
        handleChange: this._handleSortByChange,
        customStyle: {
          flex: 'none',
          alignSelf: "center"
        },
        allowToggleOff: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0",
        customStyle: {
          fontWeight: 500
        }
      }, _i18n["default"].t(_tokens["default"].labels.claims.sortDirection)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.claims.oldestFirst),
          selected: this.state.sortDirection === 'oldestFirst',
          field: 'oldestFirst'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.claims.newestFirst),
          selected: this.state.sortDirection === 'newestFirst',
          field: 'newestFirst'
        },
        handleChange: ( /*#__PURE__*/function () {
          var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(field) {
            return _regenerator["default"].wrap(function _callee5$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  if (_this2.state.sortBy) {
                    _context5.next = 2;
                    break;
                  }
                  return _context5.abrupt("return");
                case 2:
                  _context5.next = 4;
                  return _this2._handleInputChange('sortDirection', field, true);
                case 4:
                case "end":
                  return _context5.stop();
              }
            }, _callee5);
          }));
          return function (_x4) {
            return _ref4.apply(this, arguments);
          };
        }()),
        customStyle: {
          flex: 'none',
          alignSelf: "center"
        },
        allowToggleOff: true
      })), /*#__PURE__*/_react["default"].createElement("span", {
        id: "filterclaimsform"
      }));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = FilterClaims;